import { render, staticRenderFns } from "./ColorModule.vue?vue&type=template&id=3895e20f&scoped=true"
import script from "./ColorModule.vue?vue&type=script&lang=ts"
export * from "./ColorModule.vue?vue&type=script&lang=ts"
import style0 from "./ColorModule.vue?vue&type=style&index=0&id=3895e20f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3895e20f",
  null
  
)

export default component.exports